import { NavigationMenu } from '@msdyn365-commerce-modules/navigation-menu';

export { MenuSource, MenuTypeIndexId, NavigationMenu, NavigationMenuView } from '@msdyn365-commerce-modules/navigation-menu';
export default NavigationMenu;
